import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from '#src/atoms/layout/FullWidthContainer/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { HeadlineS } from '#src/atoms/typography/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

import type { Props as RelatedClubProps } from './RelatedClub/index.tsx';
import { RelatedClub } from './RelatedClub/index.tsx';

type Props = {
  clubs: RelatedClubProps['club'][];
};

export const RelatedClubs = ({ clubs }: Props) => {
  return (
    <FullWidthContainer>
      <Vertical gap={1.5}>
        <HeadlineS as="h2">
          <FormattedMessage {...glossary.relatedClubs} />
        </HeadlineS>
        {clubs.map(club => (
          <RelatedClub key={club.slug} club={club} />
        ))}
      </Vertical>
    </FullWidthContainer>
  );
};
